module.exports = __webpack_public_path__ + "img/crawfoj.74b277fd.jpg";